// extracted by mini-css-extract-plugin
export var chip = "_d5-0";
export var filterDropdown = "_d5-5";
export var filterItem = "_d5-6";
export var icon = "_d5-1";
export var removeButton = "_d5-3";
export var removeIcon = "_d5-4";
export var separator = "_d5-2";